import { CartAddEvent } from '@theme/events';

// NOXCULT — suggestions tiroir panier (snippets/nox-cart-upsell.liquid).
// Délégation sur document : survit aux re-rendus du tiroir.
const root = window.Shopify?.routes?.root || '/';

document.addEventListener('change', (e) => {
  const form = e.target.closest?.('[data-nox-upsell-form]');
  if (!form || e.target.name !== 'id') return;
  const btn = form.querySelector('.nox-upsell__add');
  btn.disabled = false;
  btn.textContent = btn.dataset.addLabel;
});

document.addEventListener('submit', async (e) => {
  const form = e.target.closest?.('[data-nox-upsell-form]');
  if (!form) return;
  e.preventDefault();

  const btn = form.querySelector('.nox-upsell__add');
  const err = form.querySelector('.nox-upsell__error');
  const id = new FormData(form).get('id');
  if (!id) return;

  btn.disabled = true;
  btn.setAttribute('aria-busy', 'true');
  err.hidden = true;

  try {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    });
    if (!res.ok) throw new Error(await res.text());
    const cart = await (await fetch(`${root}cart.js`)).json();
    document.dispatchEvent(
      new CartAddEvent(cart, 'nox-cart-upsell', {
        source: 'nox-cart-upsell',
        itemCount: cart.item_count,
        variantId: String(id),
      })
    );
  } catch (error) {
    console.error(error);
    err.hidden = false;
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
  }
});
